import React, { useRef, useState } from 'react';
import { Loader, Dimmer, TableBody, TableCell, TableRow } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';
import CatalogoProductosExistencias from '../../catalogos/catalogoProductosExistencias';
import CatalogoAlmacen from '../../catalogos/catalogoAlmacen';
import CatalogoCliente from '../../catalogos/catalogoCliente';

export const ModalImprimirFacturasCompras = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));


  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtCodigo = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtPorProduct = useRef();
  const txtNombreProducto = useRef();
  const txtTodosProduct = useRef();
  const txtTodosAlmacen = useRef();
  const txtPorAlmacen = useRef();
  const txtNombreAlmacen = useRef();
  const txtCodigoAlmacen = useRef();
  const txtNombreProveedor = useRef();
  const txtSrifp = useRef();
  const txtRifp = useRef();
  const txtTodosStatus = useRef();
  const txtPorpagar = useRef();
  const txtPagadas = useRef();
  const txtAnuladas = useRef();
  const txtGeneral = useRef();
  const txtEspecifico = useRef();

  const [inputalmacen, setInputalmacen] = useState('');
  const [valalmacen, setValalmacen] = useState(null);
  const [valproducto, setValproducto] = useState(null);
  const [opera, setOpera] = useState(0);
  const [tiporif, setTipofic] = useState(null);
  const [valproveedor, setValproveedor] = useState(0);
  const [mostrar1, setMostrar1] = useState(null);
  const [mostrar2, setMostrar2] = useState(null);
  const [mostrar3, setMostrar3] = useState(null);
  const [parafecha, setParafecha] = useState('');
  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');
  const [disponiblec, setDisponiblec] = useState('');
  const [nreport, setNreport] = useState('');
  const [idclient, setIdclient] = useState('');
  const [vinpurt, setVinput] = useState(true);
  const [valida2, setValida2] = useState(0);
  const [activate, setActivate] = useState(false);
  const [idproduct, setIdproduct] = useState('');
  const [estatus, setEstatus] = useState('');
  const [valida, setValida] = useState(0);
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [tituid, setTituid] = useState('');
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });


  const blanquear = () => {
    setActivate(false);
    setInputalmacen('');
    setParafecha('');
    setDisponiblec('');
    setNreport('');
    setOpera(0);
    setValida(0);
    setValida2(0);
    setIdclient('');
    setIdproduct('');
    setVinput(true);
    setMostrar1(false);
    setMostrar2(false);
    setEstatus("");
    setDesde('');
    setHasta('');
    setValalmacen(0);
    setValproducto(0);
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();

  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.ope === 1) {

      if (valida2 === 1 && txtTodosProduct.current.checked === false) {
        if (txtPorProduct.current.checked === true && txtCodigo.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Código del Producto a Consultar !', icono: 'informacion' });
          txtCodigo.current.focus()
          sigue = false
        } else if (txtPorProduct.current.checked === false && txtTodosProduct.current.checked === false) {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Operación !', icono: 'informacion' });
          txtTodosProduct.current.focus()
          sigue = false
        } else {
          imprimirMovimientosVentas();
        }
      } else if (sigue === true) {

        imprimirMovimientosVentas();

      }

    }

  }

  const onChange = (e) => {

    if (e.target.name === 'desde') {
      if (e.target.value > moment(fechasistema).format('YYYY-MM-DD')) {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
        txtDesde.current.value = moment(fechasistema).format('YYYY-MM-DD');
        txtDesde.current.focus()
      } else {
        setDesde(e.target.value);
      }
    } else if (e.target.name === 'hasta') {
      setHasta(e.target.value);
    }

    let valida = 1;

    if (e.target.name === 'inlineRadioOptionstipo') {
      if (e.target.value === '1') {
        valida = 1;
        setNreport('ReporteGeneralFacturasCompras');
        setOpera(2);
      } else {
        valida = 2;
        setNreport('ReporteFacturasdeCompras');
        setOpera(1);
      }
    }

    if (e.target.name === 'nci') {
      setTipofic(e.target.value);
    }

    if (e.target.name === 'inlineRadioOptionst') {

      if (e.target.value === '1') {
        setValproducto(0);
        setIdproduct("'" + ' and nd.idproducto > 0' + "'");

        if (valida === 1) {
          setNreport('ReporteGeneralFacturasCompras');
          setOpera(2);
        } else {
          setNreport('ReporteFacturasdeCompras');
          setOpera(1);
        }

        txtCodigo.current.value = "";
        txtNombreProducto.current.value = "";
      } else {
        setValproducto(1);
        setOpera(2);
        setNreport('ReporteFacturaComprasxProductos');
      }

    }

    if (e.target.name === 'alamcen') {

      if (e.target.value === '1') {
        setValalmacen(0);
        setInputalmacen('');
        txtCodigoAlmacen.current.value = "";
        txtNombreAlmacen.current.value = "";
      } else {
        setValalmacen(1);
      }

    }

    if (e.target.name === 'inlineRadioProveedor') {
      if (e.target.value === '1') {
        setValproveedor(0);
        setIdclient("'" + 'n.idproveedor > 0' + "'");
        txtSrifp.current.value = '';
        txtRifp.current.value = '';
        txtNombreProveedor.current.value = '';
      } else {
        setValproveedor(1);
      }
    }

  }

  const imprimirMovimientosVentas = () => {

    var reporte = "";
    let desdec = "'" + moment(desde).format('DD-MM-YYYY') + "'";
    let hastac = "'" + moment(hasta).format('DD-MM-YYYY') + "'";
    let condicion;
    let oper = 0;
    let val = 0;

    if (inputalmacen !== '') {
      val = 1;
    } else {
      val = 0;
    }

    let espa1 = idclient && idproduct !== '' ? '||' : '';

    let espa2 = idclient && idproduct && estatus !== '' || idclient && estatus !== '' && idproduct === '' ? '||' : '';

    let espa3 = idclient && inputalmacen !== '' && idproduct === '' && estatus === '' || idclient && idproduct && inputalmacen !== '' & estatus === '' ||
      idclient && inputalmacen && estatus !== '' && idproduct === '' || idclient && idproduct && estatus && inputalmacen !== '' ? '||' : '';

    condicion = idclient + espa1 + idproduct + espa2 + estatus + espa3 + inputalmacen;
    reporte = nreport;
    oper = opera;
    let orden = 'n.fechafactura';

    window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&condicion=" + condicion + "&desde=" + desdec + "&hasta=" + hastac + "&ope=" + oper + "&orden=" + orden + "&valalmacen=" + val, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");

  }

  const handleAceptaProducto = (values) => {
    setMostrar1(false);
    setVinput(false);
    txtNombreProducto.current.value = values.nombrecorto;
    txtCodigo.current.value = values.codigo;
    setIdproduct("'" + ' and nd.idproducto = ' + values.idproducto + "'");

  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });

  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const seleccionarProducto = (id) => {
    let campos = "idproducto, nombre";
    let nomtab = "producto";
    let nomid = "codigo";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idproducto > 0) {
            setIdproduct("'" + ' and nd.idproducto = ' + response.data.idproducto + "'");
            txtNombreProducto.current.value = response.data.nombre;
            setVinput(false);
          } else {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Código y/o Producto no Existe !', icono: 'informacion' });
            setVinput(true);
            txtCodigo.current.value = "";
            setIdproduct('');
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "notaentrega") {
          seleccionarProducto(event.target.value.toUpperCase());
        } /* else if (event.target.name === "nalmacen") {
          seleccionarAlmacen(event.target.value);
        } */
      }
    }
  };

  const handleAceptaAlmacen = (values) => {
    setMostrar2(false);
    txtNombreAlmacen.current.value = values.descripcion;
    txtCodigoAlmacen.current.value = values.idalmacen;
    setInputalmacen("'" + ' and n.idalmacen = ' + values.idalmacen + "'");
  };

  const onChekval = (e) => {

    if (e.target.name === 'tipodisponible') {
      if (e.target.value === '1') {
        setEstatus('');
      } else if (e.target.value === '2') {
        setEstatus("'" + 'and n.status = 1' + "'");
      } else if (e.target.value === '3') {
        setEstatus("'" + ' and n.status = 0' + "'");
      } else if (e.target.value === '4') {
        setEstatus("'" + ' and n.status = 4' + "'");
      }
    }

  }

  const selectResponsable = (id) => {

    let campos = '*';
    let nomtab = 'agente';
    let nomid = 'rif';
    let nomid2 = 'proveedor';

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idagente > 0) {
            txtNombreProveedor.current.value = response.data.nombre;
            setIdclient("'" + 'n.cedularif = ' + "'" + '||' + "quote_literal(" + "'" + response.data.rif + "'" + ")");
          } else {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Proveedor no Registrado !', icono: 'informacion' });
            txtNombreProveedor.current.value = '';
            txtRifp.current.value = '';
            txtSrifp.current.value = '';
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const handleCliente = (e) => {
    e.preventDefault();
    if (e.which === 13 || typeof (e.which) === 'undefined') {
      if (e.target.value !== '') {
        selectResponsable(tiporif + e.target.value);
      }
    }
  };

  const catalogoProveedor = (ope) => (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const handleAceptaProveedor = (values) => {
    setMostrar3(false);

    txtSrifp.current.value = values.rif.substring(0, 1);
    txtRifp.current.value = values.rif.substring(1, 10);
    txtNombreProveedor.current.value = values.nombre;
    setTipofic(values.rif.substring(0, 1));
    setIdclient("'" + 'n.cedularif = ' + "'" + '||' + "quote_literal(" + "'" + values.rif + "'" + ")");

  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        if (props.ope === 1) {
          txtDesde.current.value = moment(fechasistema).format('YYYY-MM-DD');
          txtHasta.current.value = moment(fechasistema).format('YYYY-MM-DD');
          setDesde(moment(fechasistema).format('YYYY-MM-DD'));
          setHasta(moment(fechasistema).format('YYYY-MM-DD'));
          setVinput(false);
          setTipofic('V');
          setIdclient("'" + 'n.idproveedor > 0' + "'");
          setNreport('ReporteGeneralFacturasCompras');
        }


      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>Imprimir Movimientos (Facturas de Compras)</h3></div>

        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0 m-0'>

          <div className='col-12 row m-0 px-0 py-2'>

            <div className='col-pd-220 px-1 mb-2'>
              <div className="input-group input-group-sm">
                <label className="input-group-text" id="inputGroup-sizing-sm">DESDE:</label>
                <input type="date" disabled={props.ope === 0 ? true : false} onChange={onChange} ref={txtDesde} name='desde' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
              </div>
            </div>

            <div className='col-pd-220 px-1 mb-2'>
              <div className="input-group input-group-sm">
                <label className="input-group-text" id="inputGroup-sizing-sm">HASTA:</label>
                <input type="date" disabled={props.ope === 0 ? true : false} onChange={onChange} ref={txtHasta} name='hasta' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
              </div>
            </div>

            <div className='col-pd-300 px-0 mb-2 row m-0 d-flex justify-content-around mb-2 ml-auto'>
              <div className="form-check form-check-inline col-pd-100 mx-2 px-1">
                <input className="form-check-input" type="radio" ref={txtGeneral} name="inlineRadioOptionstipo" onChange={onChange} id="inlineRadiotipo1" value="1" defaultChecked />
                <label className="form-check-label" for="inlineRadiotipo1" style={{ fontSize: '0.8rem' }}>GENERAL</label>
              </div>
              <div className="form-check form-check-inline col-pd-130 ml-1 px-1">
                <input className="form-check-input" type="radio" ref={txtEspecifico} name="inlineRadioOptionstipo" onChange={onChange} id="inlineRadiotipo2" value="2" />
                <label className="form-check-label" for="inlineRadiotipo2" style={{ fontSize: '0.8rem' }}>ESPECIFICO</label>
              </div>
            </div>

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fw-bold" style={{ fontSize: '0.8rem' }}>PROVEEDOR:</legend>

              <div className='col-pd-400 px-0 mb-2 row m-0 d-flex justify-content-around'>
                <div className="form-check form-check-inline col-pd-120 mx-2 px-1">
                  <input className="form-check-input" type="radio" ref={txtTodosProduct} name="inlineRadioProveedor" onChange={onChange} defaultChecked id="inlineRadiotP1" value="1" />
                  <label className="form-check-label" for="inlineRadiotP1" style={{ fontSize: '0.8rem' }}>TODOS</label>
                </div>
                <div className="form-check form-check-inline col-pd-160 ml-1 px-1">
                  <input className="form-check-input" type="radio" ref={txtPorProduct} name="inlineRadioProveedor" onChange={onChange} id="inlineRadiotP2" value="2" />
                  <label className="form-check-label" for="inlineRadiotP2" style={{ fontSize: '0.8rem' }}>POR PROVEEDOR</label>
                </div>
              </div>

              <div className='col-pd-300 px-0 mb-1'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">CEDULA/RIF:</label>
                  <select className="form-select col-3" disabled={valproveedor === 1 ? false : true} ref={txtSrifp} name='nci' onChange={onChange} aria-label="Default select example">
                    <option value="V">V</option>
                    <option value="E">E</option>
                    <option value="J">J</option>
                    <option value="P">P</option>
                    <option value="G">G</option>
                  </select>
                  <input type="text" ref={txtRifp} disabled={valproveedor === 1 ? false : true} onKeyUp={handleCliente} onBlur={handleCliente} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button disabled={valproveedor === 1 ? false : true} type="button" onClick={catalogoProveedor(1)} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>
              </div>

              <div className='col-12 px-0 mb-1'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">NOMBRE:</label>
                  <textarea type="text" disabled={true} ref={txtNombreProveedor} name='nombre' style={{ height: idproduct !== '' ? '47px' : '30px' }} className="form-control fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>
            </fieldset>

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fw-bold" style={{ fontSize: '0.8rem' }}>PRODUCTOS:</legend>

              <div className='col-pd-400 px-0 mb-2 row m-0 d-flex justify-content-around'>
                <div className="form-check form-check-inline col-pd-120 mx-2 px-1">
                  <input className="form-check-input" type="radio" ref={txtTodosProduct} name="inlineRadioOptionst" onChange={onChange} id="inlineRadiot1" value="1" defaultChecked />
                  <label className="form-check-label" for="inlineRadiot1" style={{ fontSize: '0.8rem' }}>TODOS</label>
                </div>
                <div className="form-check form-check-inline col-pd-160 ml-1 px-1">
                  <input className="form-check-input" type="radio" ref={txtPorProduct} name="inlineRadioOptionst" onChange={onChange} id="inlineRadiot2" value="2" />
                  <label className="form-check-label" for="inlineRadiot2" style={{ fontSize: '0.8rem' }}>POR PRODUCTO</label>
                </div>
              </div>

              <div className='col-pd-300 px-0 mb-2'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO PRODUCTO: </label>
                  <input autoComplete='off' type="text" disabled={valproducto === 1 ? false : true} name="notaentrega" onKeyUp={handleInputNumeroChange} onBlur={handleInputNumeroChange} ref={txtCodigo} className="form-control fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button type="button" onClick={() => setMostrar1(true)} disabled={valproducto === 1 ? false : true} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>
              </div>

              <div className='col-12 px-0 mb-1'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">NOMBRE PRODUCTO:</label>
                  <textarea type="text" disabled={true} ref={txtNombreProducto} name='nombre' style={{ height: idproduct !== '' ? '47px' : '30px' }} className="form-control fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>
            </fieldset>

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1 d-flex justify-content-center'>
              <legend className="float-none m-0 w-auto fw-bold" style={{ fontSize: '0.8rem' }}>STATUS:</legend>

              <div className='col-2'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="1" ref={txtTodosStatus} onChange={onChekval} defaultChecked id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai1" style={{ fontSize: '0.8rem' }}>
                    TOD@S
                  </label>
                </div>
              </div>

              <div className='col-3 mr-2'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="2" ref={txtPagadas} onChange={onChekval} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai2" style={{ fontSize: '0.8rem' }}>
                    PAGADAS
                  </label>
                </div>
              </div>

              <div className='col-3'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="3" ref={txtPorpagar} onChange={onChekval} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai3" style={{ fontSize: '0.8rem' }}>
                    POR PAGAR
                  </label>
                </div>
              </div>

              <div className='col-2'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="4" ref={txtAnuladas} onChange={onChekval} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai4" style={{ fontSize: '0.8rem' }}>
                    ANULADAS
                  </label>
                </div>
              </div>

            </fieldset>

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fw-bold" style={{ fontSize: '0.8rem' }}>ALMACEN:</legend>

              <div className='col-pd-400 px-0 mb-2 row m-0 d-flex justify-content-around'>

                <div className="form-check form-check-inline col-pd-120 mx-2 px-1">
                  <input className="form-check-input" name="alamcen" value="1" ref={txtTodosAlmacen} onChange={onChange} id="alamcen" type="radio" defaultChecked />
                  <label className="form-check-label" for="exampleRa1" style={{ fontSize: '0.8rem' }}>
                    TODOS
                  </label>
                </div>

                <div className="form-check form-check-inline col-pd-160 ml-1 px-1">
                  <input className="form-check-input" name="alamcen" value="2" ref={txtPorAlmacen} onChange={onChange} id="alamcen" type="radio" />
                  <label className="form-check-label" for="exampleRa2" style={{ fontSize: '0.8rem' }}>
                    POR ALMACEN
                  </label>
                </div>

              </div>

              {/* <input type='hidden' ref={txtIdProducto} /> */}

              <div className='col-pd-300 px-0 mb-2'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO ALMACEN:</label>
                  <input type="text" ref={txtCodigoAlmacen} disabled={true} /* onKeyUp={handleCliente} onBlur={handleCliente} */ className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button disabled={valalmacen === 1 ? false : true} type="button" onClick={() => setMostrar2(true)} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>
              </div>

              <div className='col-12 px-0 mb-1'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">NOMBRE DEL ALMACEN:</label>
                  <input type="text" ref={txtNombreAlmacen} disabled={true} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

            </fieldset>

          </div>

        </div>


      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">
          <div className='col-md-11 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAcepta} disabled={vinpurt} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-primary mx-1"><i className="fas fa-print">  Imprimir</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>
      <CatalogoProductosExistencias
        show={mostrar1}
        onHideCancelar={() => setMostrar1(false)}
        onHideAceptaCatalogo={handleAceptaProducto}
      />
      <CatalogoAlmacen
        show={mostrar2}
        onHideCancelar={() => setMostrar2(false)}
        onHideAceptaCatalogo={handleAceptaAlmacen}
      />
      <CatalogoCliente
        show={mostrar3}
        nomid={'proveedor'}
        onHideCancelar={() => setMostrar3(false)}
        onHideAceptaCatalogo={handleAceptaProveedor}
      />
    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/compra/ImprimirCompras.js